import CardType from "./card";
import PlayerType from "./player";

export type DirectionType = "clockwise" | "anticlockwise";

export type StateType = "waiting" | "not ready" | "started" | "game over";
export default interface GameType {
  drawPile: CardType[];
  discardPile: CardType[];
  turn: number;
  totalPlayers: number;
  players: PlayerType[];
  activePlayerId: string | null;
  tempSuit: string | null;
  direction: DirectionType;
  state: StateType;
  showChooseColour: boolean;
}

export const INIT_GAME: GameType = {
  drawPile: [],
  discardPile: [],
  turn: -1,
  totalPlayers: 0,
  players: [],
  activePlayerId: null,
  tempSuit: null,
  direction: "clockwise",
  state: "not ready",
  showChooseColour: false,
};

// Create a rotation array to simulate disorder on the deck.
// I have used the following tool: https://www.calculator.net/random-number-generator.html
export const ROTATIONS = [
  8.49, 7.64, 2.73, 4.42, -3.37, -2.31, 0.85, -3.07, -0.79, 9.14, -3.91, -6.46,
  -2.58, 6.27, 3.03, -1.29, -6.49, -5.84, 2.05, 9.92, -1.49, -3.67, 4.31, -6.16,
  5.04, 8.73, 0.25, 9.78, 4.03, -4.4, -7.64, -0.34, -5.37, 3.33, 4.48, -3.85,
  -7.34, -0.24, 1.67, 7.19, -1.07, 4.0, -4.03, -9.63, 2.96, 3.48, -4.7, -3.81,
  1.46, -7.27,
];
